import { Form } from 'antd';

import FillPassengersNavigationItem from './FillPassengersNavigationItem';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function FillPassengersNavigation({
  statement,
  returnForm,
  departureForm,
  showMobile = false,
  isCustomerBooking = false,
}) {
  const { trans } = useTranslation();
  const returnPassengers = Form.useWatch('passengers', returnForm);
  const departurePassengers = Form.useWatch('passengers', departureForm);

  return (
    <div className={`flex flex-col gap-6 ${!showMobile && 'hidden lg:flex'}`}>
      <h3 className="text-xl text-primary font-big-bold">
        {trans('chosen_tickets')}
      </h3>
      <p className="m-0 text-base font-big">
        {trans('seat')}
        {' '}
        /
        {' '}
        {trans('price_secondary')}
      </p>
      <div className="flex flex-col gap-5">
        <ul className="flex flex-col gap-[15px] style-none p-0 m-0">
          {!statement && departurePassengers?.map((passenger, index) => (
            <FillPassengersNavigationItem
              key={passenger.seat_id}
              carriageId={passenger?.carriage_id}
              seatNumber={passenger?.seat_number}
              firstName={passenger?.first_name}
              lastName={passenger?.last_name}
              seatClassId={passenger?.seat_class}
              direction="departure"
              passengerNumber={index + 1}
              price={(passenger?.initial_seat_price ?? 0)
                + (passenger?.initial_services_price ?? 0)}
              seatGroup={passenger?.seat_group_property_id}
            />
          ))}
          {statement && statement?.statementRides?.[0]?.statementSeats
            ?.filter(
              (seat) => !isCustomerBooking || seat?.statementSeatDetail,
            )
            ?.map((seat, index) => {
              let passenger;
              if (
                !seat?.passenger?.passengerFirstName || !seat?.passenger?.passengerLastName
              ) {
                passenger = departurePassengers?.find(
                  (p) => p.seat_id === seat?.id
                    && p.carrying_id === seat?.statementSeatDetail?.carriageId,
                );
              }
              return (
                <FillPassengersNavigationItem
                  key={seat?.id}
                  carriageId={seat?.statementSeatDetail?.carriageId}
                  seatNumber={seat?.statementSeatDetail?.seatNumber || seat?.seatNumber}
                  firstName={seat?.passenger?.passengerFirstName || passenger?.first_name}
                  lastName={seat?.passenger?.passengerLastName || passenger?.last_name}
                  passengerNumber={index + 1}
                  price={seat?.paymentAmount}
                  direction="departure"
                  seatClassId={seat?.seatClass?.id}
                  seatGroup={seat?.seatGroupPropertyId}
                />
              );
            })}
        </ul>
        {(returnPassengers?.length > 0 || statement?.statementRides?.[1]) && (
        <>
          <div className="w-full h-[1px] bg-gray-semi-light-gr" />
          <p className="m-0 text-base font-big">
            {trans('seat')}
            {' '}
            /
            {' '}
            {trans('price_secondary')}
          </p>
          <ul className="flex flex-col gap-[15px] style-none p-0 m-0">
            {!statement && returnPassengers?.map((passenger, index) => {
              const initialPrice = passenger?.initial_seat_price ?? 0;
              const initialServicePrice = passenger?.initial_services_price ?? 0;
              return (
                <FillPassengersNavigationItem
                  key={passenger.seat_id}
                  carriageId={passenger?.carriage_id}
                  seatNumber={passenger?.seat_number}
                  firstName={passenger?.first_name}
                  lastName={passenger?.last_name}
                  passengerNumber={index + 1}
                  price={initialPrice + initialServicePrice}
                  direction="return"
                  seatClassId={passenger?.seat_class}
                  seatGroup={passenger?.seat_group_property_id}
                />
              );
            })}
            {statement && statement?.statementRides?.[1]?.statementSeats
              ?.filter(
                (seat) => !isCustomerBooking || seat?.statementSeatDetail,
              )
              ?.map((seat, index) => {
                let passenger;
                if (!seat?.passenger?.passengerFirstName || !seat?.passenger?.passengerLastName) {
                  passenger = returnPassengers?.find((p) => p.seat_id === seat?.id
                  && p.carrying_id === seat?.statementSeatDetail?.carriageId);
                }
                return (
                  <FillPassengersNavigationItem
                    key={seat?.id}
                    carriageId={seat?.statementSeatDetail?.carriageId}
                    seatNumber={seat?.statementSeatDetail?.seatNumber || seat?.seatNumber}
                    firstName={seat?.passenger?.passengerFirstName || passenger?.first_name}
                    lastName={seat?.passenger?.passengerLastName || passenger?.last_name}
                    passengerNumber={index + 1}
                    price={seat?.paymentAmount}
                    direction="return"
                    seatClassId={seat?.seatClass?.id}
                    seatGroup={seat?.seatGroupPropertyId}
                  />
                );
              })}
          </ul>
        </>
        )}
        <div className="w-full h-[1px] bg-gray-semi-light-gr" />
      </div>
      <div />
    </div>
  );
}

export default FillPassengersNavigation;
